import * as React from 'react';
import { ToolBarButton } from './ButtonToolBar';
import { Modal } from '../Modal';

type HelpModalToolBarButtonProps = {
    helpContent:React.ReactNode
    title?:string,
    tooltip?:string,
}
export function HelpModalToolBarButton(props:HelpModalToolBarButtonProps):JSX.Element
{
    const [showModal, setShowModal] = React.useState(false);

    return (
        <>
            <ToolBarButton icon={'survey_question'} tooltip={props.tooltip || 'Hjælp'} variant='text' onClick={()=>setShowModal(true)} />
            <Modal title={props.title || 'Hjælp'} showModal={showModal} onCancel={()=>setShowModal(false)}
                content={
                    <>
                        {props.helpContent}
                    </>
                } />
        </>
    );
}